import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getProperty(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams);
}

export async function createProperty(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/property" + pathname, body);
}

export async function updateProperty(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/property" + pathname, body);
}

export async function deleteProperty(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/property" + pathname, { data: body });
}
